import { Features, Feature } from '@ardoq/api-types';
import { createStubImplementation } from '@ardoq/stub-implementation';

// Re-exporting Features because it is so broadly used alongside hasFeature
export { Features };

export type HasFeature = (feature: Feature) => boolean;

export type FeatureInterfaceImplementation = {
  hasFeature: HasFeature;
};

export const defaultImplementation: FeatureInterfaceImplementation = {
  hasFeature: () => false,
};

const stub = createStubImplementation('@ardoq/features', defaultImplementation);

/**
 * We are moving away from stub implementations for feature flags.
 * Each app is now responsible for building their own FeatureContext which
 * can be interpreted by featureOperations.hasFeature.
 *
 * ### ardoq-front
 * Use `featureContext$` to get the current feature context, if it is
 * infeasible to use the stream you can use `getFeatureContext()`.
 *
 * @deprecated Use featureOperations.hasFeature with explicit context instead
 */
export const hasFeature = stub.hasFeature;
export const registerImplementation = stub.registerImplementation;
